
import React, { useEffect, useState } from 'react'
import { adminalert, notificationsRead } from '../../service/apiService'

const Notifications = () => {
const [admindata, setAdmindata] = useState([])

const init = async () => {
    await adminalert().then((res) => {
        setAdmindata(res?.data)
    }).catch(e => console.log(e))
    await notificationsRead().catch(err => console.log(err))
}

useEffect(() => {
init()
},[])
  return (
    <div>
           <div class="right-content">
                            <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             <h1>NOTIFICATIONS</h1> 
                           </div>
                           <div class="container-fluid p-0 ">
                               <div class="card">
                                 <ul class="notifications scrollbar">
                                 {admindata?.[0]?.adminNotifications.map((itm,index) => (
                                    <li key={index} className={`${itm?.read ? '' : 'active'}`}>
                                     <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <div class="d-flex align-items-center br-right">
                                              <div>
                                                  <p className='text-white'><strong >{itm?.message}</strong> { new Date( itm?.timestamp)?.toLocaleString() } </p>
                                              </div>
                                            </div>
                                        </div>
                                     </div>            
                                    </li>
                                 ))
                                 }
                                 </ul>
                               </div>
                           </div>  
                        </div>
    </div>
  )
}

export default Notifications
